// @flow
import ShakaVideoStreamer from '../components/player/VideoStreamer/ShakaVideoStreamer/ShakaVideoStreamer';
export default ShakaVideoStreamer;
